import React, { PureComponent } from "react";
import { connect } from "react-redux";
import moment from "moment";
import PropTypes from "prop-types";
import styles from "./VisualitzacioContainerMapa.module.css";
import Mapa from "../commons/VisualitzacioMapa";
import WrapperPlegable from "../commons/WrapperPlegable";
import VisualitzacioMapaLlegenda from "./VisualitzacioMapaLlegenda";
import VisualitzacioMapaTitol from "./VisualitzacioMapaTitol";
import VisualitzacioMapaSlider from "./VisualitzacioMapaSlider";
import VisualitzacioLiniaTemporalData from "./VisualitzacioLiniaTemporalData";
import ErrorBoundaryWrapper from "../commons/ErrorBoundaryWrapper";
import {
  optionOpenStreetMap,
  optionsBaseMeteocat  
} from "../commons/ConfiguracioLayers";
import TileLayer from "../commons/TileLayer";
import BaseSMCLayer from "../commons/BaseSMCLayer";
import VectorLayer from "./VectorLayer";
import {
  getVisibilitatObservacions,
  getDataSeleccionada,
  getTipusActiu
} from "../../reducers";
import { MAPA } from "../../constantsFormularis";
import { MASCARA_DDMMYYYY } from "../../utils/dates";
import config from "../../configuracioEntorns";

const baseLayers = () => {
  return [
    {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      options: optionOpenStreetMap,
      name: "OSM",
      isBaseLayer: true,
      defaultActiveLayer: true
    }
  ];
};

class VisualitzacioContainerMapa extends PureComponent {
  renderBaseLayers(lMap, lControl) {
    const tilesLayers = baseLayers().map(
      ({ url, options, name, isBaseLayer, defaultActiveLayer }) => {
        return (
          <TileLayer
            key={name}
            url={url}
            options={options}
            name={name}
            lMap={lMap}
            lControl={lControl}
            isBaseLayer={isBaseLayer}
            defaultActiveLayer={defaultActiveLayer}
          />
        );
      }
    );

    const SMCBaseLayer = [
      <BaseSMCLayer
        key={"BaseSMC"}
        url={config.mapa.tilesUrl}
        options={optionsBaseMeteocat}
        name="Base SMC"
        lMap={lMap}
        lControl={lControl}
      />
    ];

    return tilesLayers.concat(SMCBaseLayer);
  }

  visualitzarControls = () => {
    const { observacions, tipusActiu } = this.props;
    const visualitzar =
      tipusActiu === MAPA &&
      Array.isArray(observacions) &&
      observacions.length > 0;

    return visualitzar;
  };

  getFenofaseSeleccionada = (listaFenofases, idFenofase) => {
    return listaFenofases.filter(fenofase => {
      return fenofase.id === idFenofase;
    });
  };

  getEspecieSeleccionada = (listaEspecies, idEspecie) => {
    return listaEspecies.filter(especie => {
      return especie.id === idEspecie;
    });
  };

  getNomEspecieFenofase = () => {
    const { especies, fenofases, idEspecie, idFenofase } = this.props;

    if (!idEspecie || !idFenofase) {
      return null;
    }

    const especieSeleccionada = this.getEspecieSeleccionada(
      especies,
      idEspecie
    );

    const fenofaseSeleccionada = this.getFenofaseSeleccionada(
      fenofases,
      idFenofase
    );
    return `${especieSeleccionada[0].nom} - ${fenofaseSeleccionada[0].nom}`;
  };

  listenerAfegirNovaCapa(lMap) {
    //crea un nou listener per quan s'afegueix una capa. Això pasa quan es activa i desactiva una capa del control.
    //Es valida que l'event no aixi estat cridat anteriromente orcontrols controls
    if (lMap && !lMap.listens("overlayadd")) {
      lMap.on("overlayadd", ({ layer }) => {});
    }
  }

  listenerEliminarCapa(lMap) {
    //Cuando se deselecciona la capa del control layer se ha quitar la leyenda
    if (lMap && !lMap.listens("overlayremove")) {
      lMap.on("overlayremove", ({ layer }) => {});
    }
  }

  esArrayConDatos(obj) {
    return obj && Array.isArray(obj) && obj.length > 0;
  }

  render() {
    const { observacions, dataSeleccionada } = this.props;

    const primeraData = dataSeleccionada
      ? dataSeleccionada
      : this.esArrayConDatos(observacions) && observacions[0].dataObservacio
        ? observacions[0].dataObservacio
        : null;

    const ObservacionsPrimeraData = this.esArrayConDatos(observacions)
      ? observacions.filter(observacio => {
          return observacio.dataObservacio === primeraData
            ? observacio
            : undefined;
        })
      : [];

    const dataTitulo = dataSeleccionada
      ? moment(dataSeleccionada).format(MASCARA_DDMMYYYY)
      : null;

    return (
      <div className={styles.Mapa}>
        <div className={styles.MapaTitolWrapper}>
          {this.visualitzarControls() ? <VisualitzacioMapaTitol /> : null}
          {this.visualitzarControls() ? (
            <span className={styles.MapaDataWrapper}>
              <VisualitzacioLiniaTemporalData data={dataTitulo} />{" "}
            </span>
          ) : null}
        </div>

        {
          <Mapa>
            {(lMap, lControl) => {
              if (!lMap || !lControl) {
                return;
              }

              this.listenerAfegirNovaCapa(lMap);
              this.listenerEliminarCapa(lMap);

              //Capes base
              //Afegir en un array tantes capes com calgui
              const baseTileLayers = this.renderBaseLayers(lMap, lControl);

              //Observacions
              const ObservacionsLayer = [
                <VectorLayer
                  key={"Observacions"}
                  dades={ObservacionsPrimeraData}
                  dataSeleccionada={primeraData}
                  lMap={lMap}
                  name="Observacions"
                  active={true}
                />
              ];

              //Unimos todas las capas en un nuevo array
              let layers = baseTileLayers.concat(
                ObservacionsLayer
                //comarquesLayer
              );

              //para no tener que añadir la propiedad key a cada componente
              return React.createElement(React.Fragment, {}, ...layers);
            }}
          </Mapa>
        }

        <div className={styles.MapaSliderWrapper}>
          {this.visualitzarControls() ? (
            <WrapperPlegable titol="Selector Data">
              <VisualitzacioMapaSlider />
            </WrapperPlegable>
          ) : null}
        </div>

        <div className={styles.MapaLlegendaWrapper}>
          <WrapperPlegable titol="Llegenda">
            <VisualitzacioMapaLlegenda />
          </WrapperPlegable>
        </div>
      </div>
    );
  }
}

VisualitzacioContainerMapa.propTypes = {
  props: PropTypes.object,
  dataSeleccionada: PropTypes.string,
  observacions: PropTypes.array,
  tipusActiu: PropTypes.string
};

const mapStateToProps = state => ({
  observacions: getVisibilitatObservacions(state),
  dataSeleccionada: getDataSeleccionada(state),
  tipusActiu: getTipusActiu(state)
});

export default ErrorBoundaryWrapper(
  connect(mapStateToProps)(VisualitzacioContainerMapa)
);
